import { selectAll, addClass, removeClass } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class ProductSections {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.openCollapsibleCard = selectAll("[data-open-collapsible-card]");
    this.carouselBenefitsContainer = selectAll("[data-product-benefits-carousel]");
    this.carouselBenefitsContainerMobile = selectAll("[data-product-benefits-carousel-mobile]");
    this.carouselQuotesContainer = selectAll("[data-product-quotes-carousel]");
    this.carouselRelatedProductsContainer = selectAll("[data-product-related-products-carousel]");
  }

  render() {
    this.productAccordion();
    this.benefitsCarousel();
    this.quotesCarousel();
    this.relatedProductsCarousel();
  }

  productAccordion = () => {
    for (var i = 0; i < this.openCollapsibleCard.length; i++) {
      this.openCollapsibleCard[i].addEventListener("click", function () {
        const collapsibleCard = this.nextElementSibling;
        const collapsibleCardChildren = collapsibleCard.querySelectorAll('a');
        if (this.classList.contains("active")) {
          removeClass(this, "active");
          collapsibleCard.hidden = true;
          this.setAttribute("aria-expanded", false);
          collapsibleCard.setAttribute("tabindex", "-1");
        } else {
          // Close all expanded elements
          const accordionContainer = this.parentElement.parentElement.parentElement.querySelectorAll('.product-accordion');
          accordionContainer.forEach(element => {
            const btn = element.querySelector('.product-accordion__heading');
            const panel = element.querySelector('.product-accordion__panel');
            removeClass(btn, "active");
            panel.hidden = true;
            btn.setAttribute("aria-expanded", false);
            panel.setAttribute("tabindex", "-1");
          });

          addClass(this, "active");
          collapsibleCard.hidden = false;
          this.setAttribute("aria-expanded", true);
          collapsibleCard.setAttribute("tabindex", "1");
          if (collapsibleCardChildren) {
            for (const anchor of collapsibleCardChildren) {
              anchor.classList.add('focus');
              anchor.setAttribute("tabindex", "1");
            }
          }
        }
      });
    };
  }

  benefitsCarousel = () => {
    for (var i = 0; i < this.carouselBenefitsContainer.length; i++) {
      new Swiper(this.carouselBenefitsContainer[i], {
        slidesPerView: 1,
        direction: 'vertical',
        autoHeight: true,
        breakpoints: {
          780: {
            pagination: {
              el: ".swiper-pagination-desktop",
              clickable: true
            }
          }
        }
      });
    };

    for (var i = 0; i < this.carouselBenefitsContainerMobile.length; i++) {
      new Swiper(this.carouselBenefitsContainerMobile[i], {
        slidesPerView: 1,
        autoHeight: true,
        scrollbar: {
          el: '.swiper-scrollbar-mobile',
          draggable: true,
        }
      });
    };

  };

  quotesCarousel = () => {
    for (var i = 0; i < this.carouselQuotesContainer.length; i++) {
      new Swiper(this.carouselQuotesContainer[i], {
        slidesPerView: 1,
        scrollbar: {
          el: '.swiper-scrollbar-quotes',
          draggable: true,
        },
        breakpoints: {
          780: {
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          }
        }
      });
    };


  };


  relatedProductsCarousel = () => {
    for (var i = 0; i < this.carouselRelatedProductsContainer.length; i++) {
      new Swiper(this.carouselRelatedProductsContainer[i], {
        slidesPerView: 1,
        spaceBetween: 24,
        scrollbar: {
          el: '.swiper-scrollbar-related-products',
          draggable: true,
        },
        breakpoints: {
          780: {
            slidesPerView: 3,
          }
        }
      });
    };


  };




}
